const styles = () => ({
  priceestimatecard: {
    marginBottom: '2px',
  },
  sectionBlur: {
    filter: 'blur(10px)',
    pointerEvents: 'none',
  },
  veridiCallToAction: {
    top: '0 !important',
    '@media (max-width: 959px)': {
      top: 'unset !important',
    },
  },
  veridiBoligmappaPlusSection: {
    position: 'relative',
  },
  veridiBoligmappaPlusTextSection: {
    width: 'calc(100% - 352px)',
    minHeight: '400px',
    fontSize: '18px',
    paddingBottom: '20px',

    '@media (max-width: 959px)': {
      width: '100%',
      minHeight: 'unset',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  boligmappa_plus_logo_btn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fbf3c1',
    gap: '4px',
    padding: '4px 16px',
    borderRadius: '8px',
    border: 'none',
    fontWeight: '500',
    marginTop: '15px',
    fontSize: '18px',
    height: '36px',
    '& img': {
      width: '110px',
      height: '24px',
    },
  },
  backLinkSection: {
    width: '100%',
    maxWidth: '1115px',
    margin: '20px auto',
    fontSize: '14px',

    '& button': {
      display: 'flex',
      alignItems: 'center',
      columnGap: '4px',
      fontFamily: 'inherit',
      fontSize: '14px',
      color: '#000',
      border: 'unset',
      backgroundColor: 'unset',
      cursor: 'pointer',
    },

    '& span': {
      textDecoration: 'underline',
    },
  },
  contractAdvantages: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: '25px',

    '@media (max-width: 959px)': {
      gridTemplateColumns: 'auto',
    },
  },
});

export default styles;
